import snakecaseKeys from 'snakecase-keys'
import client from '../../client'
import { TimetableId, Timetable } from '../timetables'
import { ApiResponse, PagerMeta } from '../../types'
import {
  ListParams,
  ProgramId,
  ProgramWithTimetables,
  SearchResponse,
  SearchCountParams,
  SearchCountResponse,
  ProgramDetails,
  ProgramTimetableDetails,
} from './types'

export * from './types'

export const list = async (params: ListParams) => {
  const { data, meta }: ApiResponse<ProgramWithTimetables[], PagerMeta> =
    await client.get(`/user/programs`, {
      params: snakecaseKeys({
        ...params,
        showFullReservations: params.showFullReservations ? 1 : 0,
        isOnline: params.isOnline ? 1 : 0,
      }),
    })
  return { data, meta }
}

export const get = async (id: ProgramId) => {
  const { data }: ApiResponse<ProgramDetails> = await client.get(
    `/user/programs/${id}`
  )
  return data
}

export const listTimetables = async (id: ProgramId) => {
  const { data }: ApiResponse<Timetable[]> = await client.get(
    `/user/programs/${id}/timetables`
  )
  return data
}

export const getTimetable = async (id: ProgramId, timetableId: TimetableId) => {
  const { data }: ApiResponse<ProgramTimetableDetails> = await client.get(
    `/user/programs/${id}/timetables/${timetableId}`
  )
  return data
}

export const search = async () => {
  const { data }: ApiResponse<SearchResponse> = await client.get(
    '/user/programs/search'
  )
  return data
}

export const searchCount = async (params: SearchCountParams) => {
  const { data }: ApiResponse<SearchCountResponse> = await client.get(
    '/user/programs/search/count',
    {
      params: snakecaseKeys({
        ...params,
        showFullReservations: params.showFullReservations ? 1 : 0,
      }),
    }
  )
  return data
}
